 <div class="page-wrapper">
    <section>
        <div id="carouselExampleSlidesOnly" class="carousel slide carousel-fade" data-ride="carousel" data-interval="4000">
            <div class="carousel-inner h-100">
                <div class="carousel-item active home-slide01">
                    <div class="container">
                        <div class="row justify-content-between">
                            <div class="col-lg-8 pt-5 text-shadow mx-auto mt-5 pt-5">
                                <h5 class="display-6 font-weight-semibold pb-3 text-center text-white pt-5" data-aos="fade-down" data-aos-duration="800" data-aos-delay="100" data-aos-easing="ease-in-out">MH THEME DESIGN SDN BHD </h5>
                                <h2 class="display-4 text-color font-weight-semibold text-center text-white uppercase" data-aos="fade-down" data-aos-delay="250" data-aos-duration="800" data-aos-easing="ease-in-out">
                                    {{'We design & build' | translate}}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="carousel-item home-slide02">
                    <div class="container">
                        <div class="row justify-content-between">
                            <div class="col-lg-8 pt-5 text-shadow">
                                <h5 class="display-6 font-weight-semibold pb-3 text-center text-lg-start text-white" data-aos="fade-down" data-aos-duration="800" data-aos-delay="100" data-aos-easing="ease-in-out">MH {{'Theme Design' | translate}} </h5>
                                <h2 class="display-4 text-color font-weight-semibold text-center text-lg-start text-white uppercase" data-aos="fade-down" data-aos-delay="250" data-aos-duration="800" data-aos-easing="ease-in-out">
                                    {{'We build' | translate}}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="carousel-item home-slide03">
                    <div class="container">
                        <div class="row justify-content-between">
                            <div class="col-lg-8 pt-5 text-shadow">
                                <h5 class="display-6 font-weight-semibold pb-3 text-center text-lg-start text-white" data-aos="fade-down" data-aos-duration="800" data-aos-delay="100" data-aos-easing="ease-in-out">MH {{'Theme Design' | translate}} </h5>
                                <h2 class="display-4 text-color font-weight-semibold text-center text-lg-start text-white uppercase" data-aos="fade-down" data-aos-delay="250" data-aos-duration="800" data-aos-easing="ease-in-out">
                                    {{'An extraordinary human connection' | translate}}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </section>

    <!-- <section id="introduction" data-aos="fade-up" data-aos-duration="800" data-aos-easing="ease-in-out">
        <div class="container">
            <div class="row justify-content-between">
                <div class="col-lg-8 pt-5">
                    <h5 class="display-6 font-weight-semibold pb-3 text-center text-lg-start text-white" data-aos="slide-right" data-aos-duration="800" data-aos-easing="ease-in-out">MH {{'Theme Design' | translate}} </h5>
                    <h2 class="display-4 text-color font-weight-semibold text-white uppercase" data-aos="slide-right" data-aos-delay="50" data-aos-duration="800" data-aos-easing="ease-in-out">
                        {{"A profession design & build for extraordinary human connections" | translate}}
                    </h2>
                    <div class="d-flex align-items-center justify-content-center justify-content-lg-start" data-aos="slide-right" data-aos-duration="800" data-aos-easing="ease-in-out">
                        <a class="pulse main-bg btn font-size-14 text-white rounded-0 px-5" [routerLink]="['/about']">{{'Read More' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    
    <section id="about" class="mt-5 pt-5">
        <div class="container">
            <div class="row gy-5 gy-lg-0">
                <div class="col-sm-5" data-aos="slide-right" data-aos-duration="800" data-aos-easing="ease-in-out" style="background: url('/assets/images/112034.jpg')center right no-repeat; background-size: cover; min-height: 40rem; background-position-x: 50%;"></div>
                <div class="col-sm-7 align-items-center d-flex">
                    <div class="px-5">
                        <div class="uppercase main-color font-weight-medium" data-aos="zoom-in-up" data-aos-duration="800" data-aos-easing="ease-in-out">{{"Who We Are" | translate}}</div>
                        <h2 class="text-color font-weight-semibold mb-5" data-aos="zoom-in-up" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out"> MH THEME DESIGN SDN BHD </h2>
                        <ul class="list-unstyled font-size-14 text-color list-group list-group-flush ul-tick mb-5">
                            <li class="list-group-item ps-0" data-aos="zoom-in-up" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out">
                                <i data-feather="check-square" class="icon-16 main-color"></i>
                                {{"To deliver our experience and expertise to fulfill our clients' needs and dreams" | translate}}
                            </li>
                            <li class="list-group-item ps-0" data-aos="zoom-in-up" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out">
                                <i data-feather="check-square" class="icon-16 main-color"></i>
                                {{'To provide quality assurance by complying with international standards and technologies' | translate}}
                            </li>
                            <li class="list-group-item ps-0" data-aos="zoom-in-up" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out">
                                <i data-feather="check-square" class="icon-16 main-color"></i>
                                {{"To offer our products and services at the highest standard whilst keeping within the clients' budget" | translate}}
                            </li>
                        </ul>  
                        <div class="d-flex align-items-center justify-content-center justify-content-lg-start" data-aos="zoom-in-up" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out">
                            <a class="pulse main-bg btn font-size-14 text-white rounded-0 px-5" [routerLink]="['/about']">{{'Learn More' | translate}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- <section id="client" class="mt-5 pt-5">
        <div class="container">
            <hr>
            <div class="my-5 py-5">
                <div class="uppercase main-color font-weight-medium text-center" data-aos="zoom-in" data-aos-duration="800" data-aos-easing="ease-in-out">MH {{'Theme Design' | translate}}</div>
                <h2 class="text-color font-weight-semibold text-center" data-aos="zoom-in" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out">{{'Trusted By The Industry' | translate}}</h2>
                <div class="row mt-5">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-2" data-aos="fade" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out"><img src="/assets/images/default_logo.jpg" width="200"></div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-2" data-aos="fade" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out"><img src="/assets/images/default_logo.jpg" width="200"></div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-2" data-aos="fade" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out"><img src="/assets/images/default_logo.jpg" width="200"></div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-2" data-aos="fade" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out"><img src="/assets/images/default_logo.jpg" width="200"></div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-2" data-aos="fade" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out"><img src="/assets/images/default_logo.jpg" width="200"></div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-2" data-aos="fade" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out"><img src="/assets/images/default_logo.jpg" width="200"></div>
                </div>
            </div>
            <hr>
        </div>
    </section> -->

    <section id="service" class="mt-5 pt-5">
        <div class="container">
            <div class="row gy-5 gy-lg-0">
                <div class="col-sm-7 align-items-center d-flex">
                    <div class="px-5">
                        <div class="uppercase main-color font-weight-medium" data-aos="zoom-in-up" data-aos-duration="800" data-aos-easing="ease-in-out">{{"What We Provide" | translate}}</div>
                        <h2 class="text-color font-weight-semibold" data-aos="zoom-in-up" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out">{{'Discover More About Service Provided By Us' | translate}} </h2>
                        <p class="font-size-14 accent-text-color text-justify mb-5" data-aos="zoom-in-up" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out">
                            {{"Our factory located at Kajang, Selangor Malaysia with appr 60,000 sqft. We have area of storage, spray booth, Kuka Robot room, 3D printer and other facilities." | translate}}
                            <!-- {{"Our Factory located at Balakong, Selangor, Malaysia with a appx 80,000 sqft including Factory A & B. We have Factory A (appx 27,000 sq ft) since year 2016 then we expand another Factory B (appx 53,000 sq ft) on year 2019. We have area of storage, spray booth, Kuka Robot room, 3D printer and other facilities." | translate}} -->
                        </p>
                        <div class="d-flex align-items-center justify-content-center justify-content-lg-start" data-aos="zoom-in-up" data-aos-delay="5" data-aos-duration="800" data-aos-easing="ease-in-out">
                            <a class="pulse main-bg btn font-size-14 text-white rounded-0 px-5" [routerLink]="['/facilities']">{{'Learn More' | translate}}</a>
                        </div>
                    </div>
                </div>
                <div class="col-sm-5" data-aos="slide-left" data-aos-duration="800" data-aos-easing="ease-in-out" style="background: url('/assets/images/113647.jpg')center right no-repeat; background-size: cover; min-height: 40rem; background-position-x: 50%;"></div>
            </div>
        </div>
    </section>

    <section id="category" class="mt-5 pt-5">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 categories-01bg">
                <h2 class="display-5 text-color font-weight-semibold text-white uppercase" data-aos="slide-right" data-aos-delay="50" data-aos-duration="800" data-aos-easing="ease-in-out">
                    {{'Residential' | translate}}
                </h2>
                <p style="font-size: 1.2em;" data-aos="slide-right" data-aos-delay="50" data-aos-duration="800" data-aos-easing="ease-in-out">{{'Your Dream And Our Build.' | translate}}</p>
                <div class="d-flex align-items-center justify-content-center justify-content-lg-start pt-5" data-aos="slide-right" data-aos-duration="800" data-aos-easing="ease-in-out">
                    <a class="pulse main-bg btn font-size-14 text-white rounded-0 px-5" [routerLink]="['/work']">{{'View More' | translate}}</a>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 categories-02bg">
                <h2 class="display-5 text-color font-weight-semibold text-white uppercase" data-aos="slide-right" data-aos-delay="50" data-aos-duration="800" data-aos-easing="ease-in-out">
                    {{'Hospitality' | translate}}
                </h2>
                <p style="font-size: 1.2em;" data-aos="slide-right" data-aos-delay="50" data-aos-duration="800" data-aos-easing="ease-in-out">{{'Competitive Yet Zero Hassles.' | translate}}</p>
                <div class="d-flex align-items-center justify-content-center justify-content-lg-start pt-5" data-aos="slide-right" data-aos-duration="800" data-aos-easing="ease-in-out">
                    <a class="pulse main-bg btn font-size-14 text-white rounded-0 px-5" [routerLink]="['/work']">{{'View More' | translate}}</a>
                </div>
            </div>
        </div>
    </section>

    <div class="bg-accent">
        <div class="container py-5" id="subscribe">
            <div class="row">
                <div class="col-sm-10 offset-sm-1">
                    <div class="py-5 px-4">
                        <div class="row">
                            <div class="col-12 col-lg-10 mx-auto text-center">
                                <div class="uppercase main-color font-weight-medium" data-aos="zoom-in" data-aos-duration="800" data-aos-easing="ease-in-out">{{"Join Us Now" | translate}}</div>
                                <h2 class="display-3 font-weight-bold text-center" data-aos="zoom-in" data-aos-duration="800" data-aos-easing="ease-in-out">{{"Let's Work Together To Create More Fantasy" | translate}}</h2>
                                <!-- <p class="font-size-18 accent-text-color text-center">{{'Want to learn more about our service?' | translate}}</p> -->
                                <div class="d-flex align-items-center justify-content-center" data-aos="zoom-in" data-aos-duration="800" data-aos-easing="ease-in-out">
                                    <a class="pulse white-bg btn font-size-14 text-dark rounded-0 px-5 py-3" [routerLink]="['/contact']">{{'Join Us Now' | translate}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
 </div>
    
    
    
    
    <!-- ::::::::::: INTRODUCTION :::::::::::::::-->
    <!-- <div id="introduction">
        <div class="container">
            <div class="row justify-content-between">
                <div class="col-lg-6">
                    <h1 class="display-6 font-weight-medium pb-3 text-center text-lg-start">MH 
                        {{'Theme Design' | translate}}{{' Sdn Bhd' | translate}} 
                        <br class="d-none d-md-block"> <strong> {{'SPECIALIST THEME CONTRACTOR' | translate}}</strong></h1>
                    <div class="d-flex align-items-center justify-content-center justify-content-lg-start">
                        <a class="pulse main-bg btn font-size-14 text-white rounded-0 px-4" [routerLink]="['/projects']">{{'View Now' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- ::::::::::: /END INTRODUCTION ::::::::::-->
    
    <!-- ::::::::::::::: SERVICES :::::::::::::::::::-->
    <!-- <div  id="service">
        <div class="container">
            <div class="pt-0 pt-sm-5 pb-sm-5 my-5">
                <div class="uppercase main-color font-weight-medium text-center">{{"Where Everyday Is A Great Adventure" | translate}}</div>
                <h2 class="text-color font-weight-semibold text-center mb-5">
                    MH {{'Theme Design' | translate}} 
                </h2>
                <div class="row gy-5 gy-lg-0">
                    <div class="col-sm-5">
                        <img src="assets/intro_bg.jpg" alt="..." class="wow animate__fadeIn img-fluid rounded">
                    </div>
                    <div class="col-sm-7 align-items-center d-flex">
                        <div class="px-5">
                            <h4 class="font-weight-medium text-color"><strong>{{"Our Mission" | translate}}</strong></h4>
                            <p class="font-size-14 accent-text-color text-justify">
                                Accumsan tortor posuere ac ut consequat semper viverra nam libero. Consectetur libero id faucibus nisl tincidunt eget 
                                nullam non. Sodales ut etiam sit amet. Viverra adipiscing at in tellus integer. 
                            </p>
                            <ul class="list-unstyled font-size-14 text-color list-group list-group-flush ul-tick">
                                <li class="list-group-item ps-0">
                                    <i data-feather="check-square" class="icon-16 main-color"></i>
                                    {{"To deliver our experience and expertise to fulfill our clients' needs and dreams" | translate}}
                                </li>
                                <li class="list-group-item ps-0">
                                    <i data-feather="check-square" class="icon-16 main-color"></i>
                                    {{'To provide quality assurance by complying with international standards and technologies' | translate}}
                                </li>
                                <li class="list-group-item ps-0">
                                    <i data-feather="check-square" class="icon-16 main-color"></i>
                                    {{"To offer our products and services at the highest standard whilst keeping within the clients' budget" | translate}}
                                </li>
                            </ul>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- ::::::::::::::: /END SERVICES :::::::::::::::-->

    <!-- ::::::::::::::: ENGAGEMENTS ::::::::::::::::::::-->
    <!-- <div class="container wow animate__fadeInUp pb-5">
        <div class="pt-5 mt-5 pb-5 text-center">
            <div class="uppercase main-color font-weight-medium">{{'Where Everyday Is A Great Adventure' | translate}}</div>
            <h2 class="text-color font-weight-semibold">
                MH {{'Theme Design' | translate}}
            </h2>
            <p class="font-size-14 accent-text-color">
                Lorem ipsum dolor sit amet consectetur adipiscing elit, sed do eiusmod tempor incididunt <br class="d-none d-sm-block"> soluta nobis assumenda labore quod maxime.
            </p>
        </div>
        <div class="row pb-5">
            <div class="col-sm-12 col-md-6 col-lg-3">
                <img src="assets/intro_bg.jpg" alt="..." class="wow animate__fadeIn img-fluid rounded">
                <h5 class="text-center main-color pt-4"><strong>{{'Theme Parks' | translate}}</strong></h5>
                <p class="text-justify accent-text-color px-3 font-size-14">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolorum fugit mollitia nemo, itaque sunt nam sit illo, architecto facere doloremque quisquam, temporibus eum asperiores vitae rem amet sequi ipsa quam.</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
                <img src="assets/intro_bg.jpg" alt="..." class="wow animate__fadeIn img-fluid rounded">
                <h5 class="text-center main-color pt-4"><strong>{{'Zoos' | translate}}</strong></h5>
                <p class="text-justify accent-text-color px-3 font-size-14">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolorum fugit mollitia nemo, itaque sunt nam sit illo, architecto facere doloremque quisquam, temporibus eum asperiores vitae rem amet sequi ipsa quam.</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
                <img src="assets/intro_bg.jpg" alt="..." class="wow animate__fadeIn img-fluid rounded">
                <h5 class="text-center main-color pt-4"><strong>{{'Casino' | translate}}</strong></h5>
                <p class="text-justify accent-text-color px-3 font-size-14">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolorum fugit mollitia nemo, itaque sunt nam sit illo, architecto facere doloremque quisquam, temporibus eum asperiores vitae rem amet sequi ipsa quam.</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
                <img src="assets/intro_bg.jpg" alt="..." class="wow animate__fadeIn img-fluid rounded">
                <h5 class="text-center main-color pt-4"><strong>{{'Resorts' | translate}}</strong></h5>
                <p class="text-justify accent-text-color px-3 font-size-14">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolorum fugit mollitia nemo, itaque sunt nam sit illo, architecto facere doloremque quisquam, temporibus eum asperiores vitae rem amet sequi ipsa quam.</p>
            </div>
        </div>
    </div> -->
    <!-- ::::::::::::::: /END ENGAGEMENTS :::::::::::::::-->

    <!-- ::::::::::::::: SUBSCRIBE ::::::::::::::::::::-->
    
    <!-- ::::::::::::::: /END SUBSCRIBE :::::::::::::::-->